export const isCorrectUrlForWebCrypto = () => (
  // jose uses modern webcrypto in the browser and thus need a secure context
  // See https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts
  window.location.protocol.startsWith('https') || window.location.hostname === 'localhost'
);
